export default __webpack_public_path__ + "static/media/mining.0ec63ab3.svg";